<template>
  <div class="notice-item flex-div-bet">
    <div class="left-area flex-div">
      <div v-if="showCols.typeCol&&showCols.typeCol.showFlag!==false"
           class="notice-type">{{ (showCols.typeCol && record[showCols.typeCol.propId]) || t('平台运营') }}
      </div>

      <link-text :record="record"
                 v-if="showCols.titleCol&&showCols.titleCol.showFlag!==false"
                 :showCols="dataConfig.showCols"
                 propName="titleCol"
                 :dataConfig="dataConfig"></link-text>
    </div>

    <span v-if="showCols.dateCol&&showCols.dateCol.showFlag!==false"
          class="notice-date">
        <grid-cell-ctl-show :column="showCols.dateCol" :record="record"/>
    </span>
  </div>
</template>


<script lang="ts">
import {defineComponent, toRefs} from 'vue';
import i18n from '@/i18n';

export default defineComponent({
  components: {},
  label: i18n.global.t('简单列表'),
  columns: [
    {value: 'noticeType', label: i18n.global.t('公告类型')},
    {value: 'noticeContent', label: i18n.global.t('公告内容')},
    {value: 'noticeDate', label: i18n.global.t('公告日期')}
  ],
  name: 'noticeList',
});
</script>
<script lang="ts" setup>
import GridCellCtlShow from "@/main-page/gridCellCtlShow/index.vue";
import LinkText from "@/gateway-main/commonVue/link-text.vue";
import {useI18n} from "vue-i18n";
import {toRefs} from "vue";

const {t} = useI18n();

interface propTypes {
  record: any,
  dataConfig: any,
  dateCol: any
};
const props = withDefaults(defineProps<propTypes>(), {
  record: {},
  dataConfig: {},
  dateCol: {}
})
const {dataConfig} = toRefs(props);
if (unref(dataConfig)["showCols"] == null) {
  unref(dataConfig)["showCols"] = {
    typeCol: {},
    titleCol: {},
    dateCol: {}
  };
}
const showCols = unref(dataConfig)["showCols"];

</script>

<style type="text/css" lang="less">
.notice-item {
  padding: 0 12px;
  display: flex;
  height: 42px;
  align-items: center;

  .left-area {
    height: 100%;
    align-items: center;
  }


  .notice-type {
    padding: 4px 8px;
    white-space: nowrap;
    text-align: center;
    background: #d6ebff;
    color: #0062ff;
    margin-right: 9px;
    border-radius: 2px;
    font-size: 10px;
    line-height: 16px;
  }

  .notice-title {
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 14px;
    color: #333;
    flex-grow: 1;
    padding: 0 28px 0 8px;
    cursor: pointer;
  }

  .notice-date {
    font-size: 12px;
    white-space: nowrap;
    line-height: 16px;
    color: #999;
  }
}
</style>
